import { useTeamId } from "@coworker/app/src/core/auth/useLoggedInUser";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { useEffect } from "react";
import { useLocation } from "react-router";

const TEAM_SELECTION_PATH = "/teamselection";
const NEW_USER_PATH = "/newuser";
const NEW_USER_TEAM_SELECTION_PATH = "/newuserteamselection";

const TEAM_SELECTION_PATHS = new Set([
  TEAM_SELECTION_PATH,
  NEW_USER_PATH,
  NEW_USER_TEAM_SELECTION_PATH,
]);

/**
 * Hook to ensure the user is a member of a team.
 * If the user is not a member of a team, they will be redirected to the team selection page.
 * If the user is in the team selection page, the hook will not redirect them to avoid redirect loops.
 *
 * @returns { isVerified: boolean } - Returns an object with a boolean indicating if the user's team is verified.
 */
export const useEnsureUserTeamMembership = () => {
  const navigate = useFixaNavigate();

  const location = useLocation();
  const isOnTeamSelectionPage = TEAM_SELECTION_PATHS.has(location.pathname);

  const teamId = useTeamId();

  useEffect(() => {
    if (isOnTeamSelectionPage) {
      return;
    }

    if (!teamId) {
      navigate(TEAM_SELECTION_PATH, { replace: true });
    }
  }, [teamId, navigate, isOnTeamSelectionPage]);

  return { isVerified: isOnTeamSelectionPage || !!teamId };
};
